import React, { useRef } from "react";
import { NiceModal } from "@castlery/fortress";
import {
  BUTTON_TAG,
  CLICK_ACTION,
  TRACK_EVENT,
  trackEvent,
} from "@/utils/analytics";

interface LoginProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onLogin: () => void;
  onCancel: () => void;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export const Login: React.FC<LoginProps> = ({
  open,
  onOpenChange,
  onLogin,
  onCancel,
  containerRef,
}) => {
  const isCanceling = useRef(false);

  const handleConfirm = () => {
    trackEvent({
      event: TRACK_EVENT,
      category: "login",
      action: CLICK_ACTION,
      tag: BUTTON_TAG,
      tag_value: "confirm",
    });

    onLogin();
    onOpenChange(false);
  };

  const handleCancel = () => {
    if (isCanceling.current) return;
    isCanceling.current = true;

    trackEvent({
      event: TRACK_EVENT,
      category: "login",
      action: CLICK_ACTION,
      tag: BUTTON_TAG,
      tag_value: "cancel",
    });

    onCancel();
    onOpenChange(false);
  };

  const handleClose = () => {
    if (isCanceling.current) {
      isCanceling.current = false;
      return;
    }

    trackEvent({
      event: TRACK_EVENT,
      category: "login",
      action: CLICK_ACTION,
      tag: BUTTON_TAG,
      tag_value: "close",
    });

    onCancel();
    onOpenChange(false);
    isCanceling.current = true;
  };

  return (
    <NiceModal
      title="Log in to continue"
      desc="For your privacy and security, please log in to your account before viewing your personal details."
      open={open}
      onClose={handleClose}
      isSilent={false}
      onConfirm={handleConfirm}
      confirmText="LOG IN"
      onCancel={handleCancel}
      cancelText="CANCEL"
      container={containerRef?.current}
      disableEnforceFocus={true}
      modalSlotProps={{
        backdrop: { sx: { position: "absolute", inset: 0 } },
        root: { sx: { position: "absolute", inset: 0 } },
      }}
      dialogSx={{
        maxWidth: "90%",
      }}
      // confirmation={true}
      info={true}
    />
  );
};
